module.exports = __webpack_public_path__ + "static/appTabImg1-281bee3dd08de574c74bb452a0f05e0a.png";